<div #messageElement *ngIf="message$ | async as message" class="message-container">
  <ng-container *ngIf="!message.excluded || custom">
    <div class="alert alert-{{ message.type }} alert-dismissible fade show mb-0 {{ cssStyle }}" role="alert">
      {{ message.message }}
      <button
        *ngIf="closeVisible"
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        [attr.aria-label]="'shared.close' | translate"
        (click)="onClose()"
      ></button>
    </div>
  </ng-container>
</div>
